
import { MessagingMessageFormat, MessagingMessagePushButton } from 'emma-common-ts/emma';
import { ISO6391 as LANGUAGES } from 'emma-common-ts';

export const testAbColors = (): Array<string> => {
  return ['altpink', 'altblue', 'altorange', 'altyellow'];
};
export const testAbOriginalVersionColor = (): string => {
  return 'altgreen';
};
export const testAbControlGroupColor = (): string => {
  return 'altviolet';
};
export const testAbVersionLetters = (): Array<string> => {
  return ['A', 'B', 'C', 'D'];
};

export const DEFAULT_LANGUAGE = LANGUAGES.ES;

export const fieldsEmptyByLanguage: Readonly<Array<keyof MessagingMessageFormat>> = [
  'title',
  'message',
  'url',
  'image_url',
  'html_body',
  'subject',
  'target_url',
  'tab_title',
];

export const fieldsButtonEmptyByLanguage: Readonly<Array<keyof MessagingMessagePushButton>> = ['buttonLabel'];
